import { IFileGateway } from '@/core/interface';

export class FileGateway implements IFileGateway {

  public async upload(file: File, uploadUrl: string, mimeType?: string): Promise<void> {
    const result = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': mimeType ? mimeType : file.type,
      },
      body: file,
    });

    if (!result.ok) {
      throw new Error(`Upload failed: ${result.statusText}`);
    }
  }
}
